interface Props {
  color?: string;
  width?: string;
  height?: string;
  className?: string;
  fillOpacity?: string;
}

const EyeIcon = ({
  color = '#151411',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.76282 10.3536C1.76282 10.3536 6.33956 1.20007 14.3489 1.20007C22.3582 1.20007 26.9349 10.3536 26.9349 10.3536C26.9349 10.3536 22.3582 19.507 14.3489 19.507C6.33956 19.507 1.76282 10.3536 1.76282 10.3536Z"
      stroke="#151411"
      strokeWidth="2.28837"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3489 13.7861C16.2446 13.7861 17.7814 12.2493 17.7814 10.3536C17.7814 8.45781 16.2446 6.921 14.3489 6.921C12.4531 6.921 10.9163 8.45781 10.9163 10.3536C10.9163 12.2493 12.4531 13.7861 14.3489 13.7861Z"
      stroke="#151411"
      strokeWidth="2.28837"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const EyeClosedIcon = ({
  color = '#151411',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.53 4.53a.75.75 0 0 0-1.06-1.06l-16 16a.75.75 0 1 0 1.06 1.06l2.847-2.847c1.367.644 2.94 1.067 4.623 1.067c2.684 0 5.09-1.077 6.82-2.405c.867-.665 1.583-1.407 2.089-2.136c.492-.709.841-1.486.841-2.209c0-.723-.35-1.5-.841-2.209c-.506-.729-1.222-1.47-2.088-2.136c-.263-.201-.54-.397-.832-.583L20.53 4.53ZM16.9 8.161l-1.771 1.771a3.75 3.75 0 0 1-5.197 5.197l-1.417 1.416A9.25 9.25 0 0 0 12 17.25c2.287 0 4.38-.923 5.907-2.095c.762-.585 1.364-1.218 1.77-1.801c.419-.604.573-1.077.573-1.354c0-.277-.154-.75-.573-1.354c-.406-.583-1.008-1.216-1.77-1.801c-.313-.24-.65-.47-1.008-.684Zm-5.87 5.87a2.25 2.25 0 0 0 3-3l-3 3Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12 5.25c1.032 0 2.024.16 2.951.431a.243.243 0 0 1 .1.407l-.824.825a.254.254 0 0 1-.237.067A8.872 8.872 0 0 0 12 6.75c-2.287 0-4.38.923-5.907 2.095c-.762.585-1.364 1.218-1.77 1.801c-.419.604-.573 1.077-.573 1.354c0 .277.154.75.573 1.354c.354.51.858 1.057 1.488 1.577c.116.095.127.27.02.377l-.708.709a.246.246 0 0 1-.333.016a9.52 9.52 0 0 1-1.699-1.824C2.6 13.5 2.25 12.723 2.25 12c0-.723.35-1.5.841-2.209c.506-.729 1.222-1.47 2.088-2.136C6.91 6.327 9.316 5.25 12 5.25Z"
    />
    <path
      fill="currentColor"
      d="M12 8.25c.118 0 .236.005.351.016c.197.019.268.254.129.394l-1.213 1.212a2.256 2.256 0 0 0-1.395 1.395L8.66 12.48c-.14.14-.375.068-.394-.129A3.75 3.75 0 0 1 12 8.25Z"
    />
  </svg>
);
const SearchIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      d="M21.71 20.29L18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.39ZM11 18a7 7 0 1 1 7-7a7 7 0 0 1-7 7Z"
    />
  </svg>
);
const BellIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2V2.28988C12.8915 3.15043 15 5.82898 15 9V14C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15C0 14.4477 0.447715 14 1 14V9C1 5.82898 3.10851 3.15043 6 2.28988V2C6 0.89543 6.8954 0 8 0C9.1046 0 10 0.89543 10 2ZM3 14H13V9C13 6.23858 10.7614 4 8 4C5.23858 4 3 6.23858 3 9V14ZM10 16H6C6 17.1046 6.8954 18 8 18C9.1046 18 10 17.1046 10 16Z"
      fill="#151411"
    />
  </svg>
);
const DashboardIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C6.20914 0 8 1.79086 8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0ZM4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2ZM14 0C16.2091 0 18 1.79086 18 4C18 6.20914 16.2091 8 14 8C11.7909 8 10 6.20914 10 4C10 1.79086 11.7909 0 14 0ZM14 2C12.8954 2 12 2.89543 12 4C12 5.10457 12.8954 6 14 6C15.1046 6 16 5.10457 16 4C16 2.89543 15.1046 2 14 2ZM8 14C8 11.7909 6.20914 10 4 10C1.79086 10 0 11.7909 0 14C0 16.2091 1.79086 18 4 18C6.20914 18 8 16.2091 8 14ZM2 14C2 12.8954 2.89543 12 4 12C5.10457 12 6 12.8954 6 14C6 15.1046 5.10457 16 4 16C2.89543 16 2 15.1046 2 14ZM14 10C16.2091 10 18 11.7909 18 14C18 16.2091 16.2091 18 14 18C11.7909 18 10 16.2091 10 14C10 11.7909 11.7909 10 14 10ZM14 12C12.8954 12 12 12.8954 12 14C12 15.1046 12.8954 16 14 16C15.1046 16 16 15.1046 16 14C16 12.8954 15.1046 12 14 12Z"
      fill="#151411"
    />
  </svg>
);
const AnalyticsIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 9C22 8.32542 21.9242 7.65461 21.775 7C21.6628 6.5077 21.5091 6.02455 21.3149 5.55585C20.8626 4.46392 20.1997 3.47177 19.364 2.63604C18.5282 1.80031 17.5361 1.13738 16.4442 0.68508C15.9754 0.49094 15.4923 0.33724 15 0.22504C14.3454 0.07584 13.6746 0 13 0V9H22ZM19.4672 6.32122C19.5593 6.54361 19.6397 6.77018 19.7082 7H15V2.2918C15.2298 2.36031 15.4564 2.44073 15.6788 2.53284C16.5281 2.88463 17.2997 3.40024 17.9497 4.05025C18.5998 4.70026 19.1154 5.47194 19.4672 6.32122ZM9 4C4.02944 4 0 8.02944 0 13C0 17.9706 4.02944 22 9 22C13.9706 22 18 17.9706 18 13C18 12.3254 17.9242 11.6546 17.775 11H11V4.22504C10.3454 4.07584 9.6746 4 9 4ZM9 13H15.8035C15.8035 16.7575 12.7575 19.8035 9 19.8035C5.24252 19.8035 2.19648 16.7575 2.19648 13C2.19648 9.2425 5.24252 6.19648 9 6.19648V13Z"
      fill="#171717"
    />
  </svg>
);
const CustomerIcon = ({ color = '#8F92A1', className }: Props) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7ZM14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7Z"
      fill="#171717"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 15C16 14.4477 15.5523 14 15 14H9C8.44772 14 8 14.4477 8 15V21H6V15C6 13.3431 7.34315 12 9 12H15C16.6569 12 18 13.3431 18 15V21H16V15Z"
      fill="#171717"
    />
  </svg>
);
const StaffIcon = ({ color = '#8F92A1', className }: Props) => (
  <svg
    className={className}
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4C10 6.20914 8.2091 8 6 8C3.79086 8 2 6.20914 2 4C2 1.79086 3.79086 0 6 0C8.2091 0 10 1.79086 10 4ZM8 4C8 5.10457 7.1046 6 6 6C4.8954 6 4 5.10457 4 4C4 2.89543 4.8954 2 6 2C7.1046 2 8 2.89543 8 4ZM16 8C18.2091 8 20 6.20914 20 4C20 1.79086 18.2091 0 16 0C13.7909 0 12 1.79086 12 4C12 6.20914 13.7909 8 16 8ZM16 6C17.1046 6 18 5.10457 18 4C18 2.89543 17.1046 2 16 2C14.8954 2 14 2.89543 14 4C14 5.10457 14.8954 6 16 6ZM19 11C19.5523 11 20 11.4477 20 12V18H22V12C22 10.3431 20.6569 9 19 9H14L15 11H19ZM9 11C9.5523 11 10 11.4477 10 12V18H12V12C12 10.3431 10.6569 9 9 9H3C1.34315 9 0 10.3431 0 12V18H2V12C2 11.4477 2.44772 11 3 11H9Z"
      fill="#171717"
    />
  </svg>
);
const ChevronUpIcon = ({
  color = '#8F92A1',
  width = '22',
  height = '22',
  className,
}: Props) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
  >
    <path fill={color} d="m16 10l10 10l-1.4 1.4l-8.6-8.6l-8.6 8.6L6 20z" />
  </svg>
);
const ChevronDownIcon = ({
  color = '#8F92A1',
  width = '22',
  height = '22',
  className,
}: Props) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
  >
    <path fill={color} d="M16 22L6 12l1.4-1.4l8.6 8.6l8.6-8.6L26 12z" />
  </svg>
);
const FileIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3C0 1.34315 1.34315 0 3 0H11C14.866 0 18 3.13401 18 7V17C18 18.6569 16.6569 20 15 20H3C1.34315 20 0 18.6569 0 17V3ZM10 2H3C2.44772 2 2 2.44772 2 3V17C2 17.5523 2.44772 18 3 18H15C15.5523 18 16 17.5523 16 17V7H10V2ZM15.584 5C14.9413 3.52906 13.6113 2.4271 12 2.10002V5H15.584Z"
      fill="#171717"
    />
  </svg>
);
const ListIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 2H3C2.44771 2 2 2.44772 2 3V17C2 17.5523 2.44772 18 3 18H19C19.5523 18 20 17.5523 20 17V3C20 2.44771 19.5523 2 19 2ZM3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H19C20.6569 20 22 18.6569 22 17V3C22 1.34315 20.6569 0 19 0H3ZM5 5H7V7H5V5ZM10 5C9.4477 5 9 5.44772 9 6C9 6.55228 9.4477 7 10 7H16C16.5523 7 17 6.55228 17 6C17 5.44772 16.5523 5 16 5H10ZM7 9H5V11H7V9ZM9 10C9 9.4477 9.4477 9 10 9H16C16.5523 9 17 9.4477 17 10C17 10.5523 16.5523 11 16 11H10C9.4477 11 9 10.5523 9 10ZM7 13H5V15H7V13ZM9 14C9 13.4477 9.4477 13 10 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H10C9.4477 15 9 14.5523 9 14Z"
      fill="#171717"
    />
  </svg>
);
const StoreIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 4H1C0.447715 4 0 4.44772 0 5V9C0.00356437 10.2683 0.804271 11.3973 2 11.82V21C2 21.5523 2.44772 22 3 22H19C19.5523 22 20 21.5523 20 21V11.82C21.1957 11.3973 21.9964 10.2683 22 9V5C22 4.44772 21.5523 4 21 4ZM14 6H16V9C16 9.55228 15.5523 10 15 10C14.4477 10 14 9.55228 14 9V6ZM10 6H12V9C12 9.55228 11.5523 10 11 10C10.4477 10 10 9.55228 10 9V6ZM6 6H8V9C8 9.55228 7.55228 10 7 10C6.44772 10 6 9.55228 6 9V6ZM3 10C2.44772 10 2 9.55228 2 9V6H4V9C4 9.55228 3.55228 10 3 10ZM13 20H9V18C9 16.8954 9.89543 16 11 16C12.1046 16 13 16.8954 13 18V20ZM18 20H15V18C15 15.7909 13.2091 14 11 14C8.79086 14 7 15.7909 7 18V20H4V11.82C4.36757 11.6836 4.70664 11.4801 5 11.22C6.1388 12.2386 7.8612 12.2386 9 11.22C10.1388 12.2386 11.8612 12.2386 13 11.22C14.1388 12.2386 15.8612 12.2386 17 11.22C17.2934 11.4801 17.6324 11.6836 18 11.82V20ZM20 9C20 9.55228 19.5523 10 19 10C18.4477 10 18 9.55228 18 9V6H20V9ZM3.3 2H19C19.5523 2 20 1.55228 20 1C20 0.447715 19.5523 0 19 0H3.3C2.74772 0 2.3 0.447715 2.3 1C2.3 1.55228 2.74772 2 3.3 2Z"
      fill="#171717"
    />
  </svg>
);
const ProfileIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM3.90798 16.5417C2.71255 15.014 2 13.0902 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 13.0524 19.313 14.9443 18.1565 16.4583C16.5092 14.3531 13.9448 13 11.0645 13C8.14627 13 5.55245 14.3889 3.90798 16.5417ZM5.32767 17.9878C6.87565 19.2459 8.84977 20 11 20C13.1881 20 15.1939 19.2191 16.7538 17.9209C15.4833 16.1521 13.4084 15 11.0645 15C8.69106 15 6.59352 16.1812 5.32767 17.9878ZM11 12C13.2091 12 15 10.2091 15 8C15 5.79086 13.2091 4 11 4C8.79086 4 7 5.79086 7 8C7 10.2091 8.79086 12 11 12ZM11 10C12.1046 10 13 9.1046 13 8C13 6.89543 12.1046 6 11 6C9.8954 6 9 6.89543 9 8C9 9.1046 9.8954 10 11 10Z"
      fill="#171717"
    />
  </svg>
);
const ChevronFillDownIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
  fillOpacity = '0.4',
}: Props) => (
  <svg
    className={className}
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.29104 1.70743C9.92144 1.07759 9.47537 0 8.58425 0H1.41268C0.521988 0 0.0757232 1.07669 0.705251 1.70679L4.28781 5.29257C4.67815 5.68327 5.31132 5.68356 5.70202 5.29321L9.29104 1.70743Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  </svg>
);
const InfoIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    aria-hidden="true"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
      clipRule="evenodd"
    ></path>
  </svg>
);
const LogoutIcon = ({
  color = '#DE350B',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.51465 16H6.51465V14H2.51465V2H6.51465V0H2.51465C1.41008 0 0.514648 0.89543 0.514648 2V14C0.514648 15.1046 1.41008 16 2.51465 16ZM13.2624 11.9768L11.8422 13.385L5.50527 6.9941L11.8962 0.6572L13.3044 2.0774L9.3239 6.0242H18.4861C19.0384 6.0242 19.4861 6.4719 19.4861 7.0242C19.4861 7.5765 19.0384 8.0242 18.4861 8.0242H9.3432L13.2624 11.9768Z"
      fill={color}
    />
  </svg>
);
const PlusIcon = ({
  color = '#DE350B',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C7.4477 0 7 0.44772 7 1V7H1C0.44772 7 0 7.4477 0 8C0 8.5523 0.44772 9 1 9H7V15C7 15.5523 7.4477 16 8 16C8.5523 16 9 15.5523 9 15V9H15C15.5523 9 16 8.5523 16 8C16 7.4477 15.5523 7 15 7H9V1C9 0.44772 8.5523 0 8 0Z"
      fill="white"
    />
  </svg>
);
const ThreeDotsIcon = ({
  color = '#DE350B',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="16"
    height="4"
    viewBox="0 0 16 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2C4 3.1046 3.10457 4 2 4C0.89543 4 0 3.1046 0 2C0 0.8954 0.89543 0 2 0C3.10457 0 4 0.8954 4 2ZM10 2C10 3.1046 9.1046 4 8 4C6.8954 4 6 3.1046 6 2C6 0.8954 6.8954 0 8 0C9.1046 0 10 0.8954 10 2ZM16 2C16 3.1046 15.1046 4 14 4C12.8954 4 12 3.1046 12 2C12 0.8954 12.8954 0 14 0C15.1046 0 16 0.8954 16 2Z"
      fill="#8F92A1"
    />
  </svg>
);
const LongArrowLeftIcon = ({
  color = '#171717',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3287 5.0002V7.0002H4.50042L7.7429 10.2428L6.32872 11.657L0.671875 6.0001L6.32872 0.343262L7.7429 1.75747L4.50019 5.0002H17.3287Z"
      fill={color}
    />
  </svg>
);
const FileUploadIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 11.9861C7.4477 11.9861 7 11.5384 7 10.9861V3.82854L3.75748 7.0711L2.34326 5.65685L8.0001 0L13.657 5.65685L12.2428 7.0711L9 3.82831V10.9861C9 11.5384 8.5523 11.9861 8 11.9861ZM2 10H0V14C0 15.1046 0.89543 16 2 16H14C15.1046 16 16 15.1046 16 14V10H14V14H2V10Z"
      fill={color}
    />
  </svg>
);
const XMarkIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    preserveAspectRatio="xMidYMid meet"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 1.41L13.09 0L7.5 5.59L1.91 0L0.5 1.41L6.09 7L0.5 12.59L1.91 14L7.5 8.41L13.09 14L14.5 12.59L8.91 7L14.5 1.41Z"
      fill="currentColor"
    />
  </svg>
);
const PushNotificationsIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 6C14.6569 6 16 4.65685 16 3C16 1.34315 14.6569 0 13 0C11.3431 0 10 1.34315 10 3C10 4.65685 11.3431 6 13 6ZM0 2H8V4H2V14H12V8H14V16H0V2Z"
      fill="#171717"
    />
  </svg>
);
const SettingsIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0435 11.3069C17.7118 10.9294 17.7118 10.3644 18.0435 9.98688L19.3235 8.54688C19.6128 8.22411 19.6613 7.75166 19.4435 7.37688L17.4435 3.91688C17.2279 3.54258 16.7964 3.349 16.3735 3.43688L14.4935 3.81688C13.9984 3.91917 13.5049 3.63592 13.3435 3.15688L12.7335 1.32688C12.5959 0.919567 12.2134 0.645769 11.7835 0.646878H7.78346C7.33531 0.623487 6.92645 0.901507 6.78346 1.32688L6.22346 3.15688C6.06204 3.63592 5.56851 3.91917 5.07346 3.81688L3.14346 3.43688C2.7438 3.3804 2.34937 3.56973 2.14346 3.91688L0.143459 7.37688C-0.0798071 7.74745 -0.0394549 8.21957 0.243459 8.54688L1.51346 9.98688C1.8451 10.3644 1.8451 10.9294 1.51346 11.3069L0.243459 12.7469C-0.0394549 13.0742 -0.0798071 13.5463 0.143459 13.9169L2.14346 17.3769C2.35903 17.7512 2.79056 17.9448 3.21346 17.8569L5.09346 17.4769C5.58851 17.3746 6.08204 17.6578 6.24346 18.1369L6.85346 19.9669C6.99645 20.3923 7.40531 20.6703 7.85346 20.6469H11.8535C12.2834 20.648 12.6659 20.3742 12.8035 19.9669L13.4135 18.1369C13.5749 17.6578 14.0684 17.3746 14.5635 17.4769L16.4435 17.8569C16.8664 17.9448 17.2979 17.7512 17.5135 17.3769L19.5135 13.9169C19.7313 13.5421 19.6828 13.0696 19.3935 12.7469L18.0435 11.3069ZM16.5535 12.6469L17.3535 13.5469L16.0735 15.7669L14.8935 15.5269C13.4027 15.2221 11.9198 16.0818 11.4435 17.5269L11.0635 18.6469H8.50346L8.14346 17.5069C7.66708 16.0618 6.18425 15.2021 4.69346 15.5069L3.51346 15.7469L2.21346 13.5369L3.01346 12.6369C4.03203 11.4981 4.03203 9.77568 3.01346 8.63688L2.21346 7.73688L3.49346 5.53688L4.67346 5.77688C6.16425 6.08162 7.64708 5.222 8.12346 3.77688L8.50346 2.64688H11.0635L11.4435 3.78688C11.9198 5.232 13.4027 6.09162 14.8935 5.78688L16.0735 5.54688L17.3535 7.76688L16.5535 8.66688C15.5468 9.80257 15.5468 11.5112 16.5535 12.6469ZM9.78346 6.64688C7.57432 6.64688 5.78346 8.43774 5.78346 10.6469C5.78346 12.856 7.57432 14.6469 9.78346 14.6469C11.9926 14.6469 13.7835 12.856 13.7835 10.6469C13.7835 9.58601 13.362 8.5686 12.6119 7.81845C11.8617 7.06831 10.8443 6.64688 9.78346 6.64688ZM9.78346 12.6469C8.67889 12.6469 7.78346 11.7514 7.78346 10.6469C7.78346 9.54231 8.67889 8.64688 9.78346 8.64688C10.888 8.64688 11.7835 9.54231 11.7835 10.6469C11.7835 11.7514 10.888 12.6469 9.78346 12.6469Z"
      fill="#171717"
    />
  </svg>
);
const ChevronRight = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.333374 1.27616L1.27624 0.333344L5.99024 5.0474L1.27624 9.76146L0.333374 8.8186L4.10464 5.0474L0.333374 1.27616Z"
      fill="#8F92A1"
    />
  </svg>
);
const ShareIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="16"
    className={className}
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 11.9861C7.4477 11.9861 7 11.5384 7 10.9861V3.82854L3.75748 7.0711L2.34326 5.65685L8.0001 0L13.657 5.65685L12.2428 7.0711L9 3.82831V10.9861C9 11.5384 8.5523 11.9861 8 11.9861ZM2 10H0V14C0 15.1046 0.89543 16 2 16H14C15.1046 16 16 15.1046 16 14V10H14V14H2V10Z"
      fill="white"
    />
  </svg>
);
const ThickDownArrow = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="10"
    height="7"
    className={className}
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.29104 2.4191C9.92144 1.78926 9.47537 0.71167 8.58425 0.71167H1.41268C0.521988 0.71167 0.0757232 1.78836 0.705251 2.41846L4.28781 6.00424C4.67815 6.39494 5.31132 6.39523 5.70202 6.00488L9.29104 2.4191Z"
      fill="#8F92A1"
      fillOpacity="0.4"
    />
  </svg>
);
const EmptyStateIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    className={className}
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="currentColor">
      <path
        d="M21 15.998v-6c0-2.828 0-4.242-.879-5.121C19.353 4.109 18.175 4.012 16 4H8c-2.175.012-3.353.109-4.121.877C3 5.756 3 7.17 3 9.998v6c0 2.829 0 4.243.879 5.122c.878.878 2.293.878 5.121.878h6c2.828 0 4.243 0 5.121-.878c.879-.88.879-2.293.879-5.122Z"
        opacity=".5"
      />
      <path d="M8 3.5A1.5 1.5 0 0 1 9.5 2h5A1.5 1.5 0 0 1 16 3.5v1A1.5 1.5 0 0 1 14.5 6h-5A1.5 1.5 0 0 1 8 4.5v-1Z" />
      <path
        fillRule="evenodd"
        d="M12 9.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V16a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V10a.75.75 0 0 1 .75-.75Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
const MenuIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M4 18q-.425 0-.713-.288T3 17q0-.425.288-.713T4 16h11q.425 0 .713.288T16 17q0 .425-.288.713T15 18H4Zm0-5q-.425 0-.713-.288T3 12q0-.425.288-.713T4 11h8q.425 0 .713.288T13 12q0 .425-.288.713T12 13H4Zm0-5q-.425 0-.713-.288T3 7q0-.425.288-.713T4 6h11q.425 0 .713.288T16 7q0 .425-.288.713T15 8H4Zm13.4 4l2.9 2.9q.275.275.275.7t-.275.7q-.275.275-.7.275t-.7-.275l-3.6-3.6q-.3-.3-.3-.7t.3-.7l3.6-3.6q.275-.275.7-.275t.7.275q.275.275.275.7t-.275.7L17.4 12Z"
    />
  </svg>
);
const PaginationLeftIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.16667 9.16665L1 4.99998L5.16667 0.833313M11 9.16665L6.83333 4.99998L11 0.833313"
      stroke="#344054"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const PaginationRightIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.83333 0.833354L11 5.00002L6.83333 9.16669M1 0.833355L5.16667 5.00002L1 9.16669"
      stroke="#344054"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ShortArrowLeftIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8333 7.00002H1.16663M1.16663 7.00002L6.99996 12.8334M1.16663 7.00002L6.99996 1.16669"
      stroke="#344054"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ShortArrowRightIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.16663 7.00002H12.8333M12.8333 7.00002L6.99996 1.16669M12.8333 7.00002L6.99996 12.8334"
      stroke="#344054"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const MarketingIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="24"
    className={className}
    height="15"
    viewBox="0 0 24 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 11.1738V3.17383C2 2.62155 2.44772 2.17383 3 2.17383H16.6202C16.9121 2.17383 17.1895 2.30139 17.3795 2.52304L20.808 6.52303C21.129 6.89753 21.129 7.45013 20.808 7.82463L17.3795 11.8246C17.1895 12.0462 16.9121 12.1738 16.6202 12.1738H3C2.44772 12.1738 2 11.7261 2 11.1738ZM0 11.1738V3.17383C0 1.51698 1.34315 0.173828 3 0.173828H16.6202C17.496 0.173828 18.328 0.556518 18.898 1.22146L22.3265 5.22143C23.2895 6.34493 23.2895 8.00273 22.3265 9.12623L18.898 13.1262C18.328 13.7911 17.496 14.1738 16.6202 14.1738H3C1.34315 14.1738 0 12.8307 0 11.1738ZM16 7.17383C16 7.72613 15.5523 8.17383 15 8.17383C14.4477 8.17383 14 7.72613 14 7.17383C14 6.62153 14.4477 6.17383 15 6.17383C15.5523 6.17383 16 6.62153 16 7.17383ZM18 7.17383C18 8.83073 16.6569 10.1738 15 10.1738C13.3431 10.1738 12 8.83073 12 7.17383C12 5.51693 13.3431 4.17383 15 4.17383C16.6569 4.17383 18 5.51693 18 7.17383Z"
      fill="#171717"
    />
  </svg>
);
const GiftIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0012 0.878677C15.8296 -0.292893 13.9302 -0.292893 12.7586 0.878677L11.3444 2.29289C11.2841 2.35317 11.2269 2.41538 11.1728 2.47931C11.1188 2.41539 11.0616 2.3532 11.0013 2.29293L9.58712 0.878708C8.41557 -0.292863 6.51607 -0.292863 5.3445 0.878708C4.17293 2.05029 4.17293 3.94978 5.3445 5.12136L6.22314 6H0.46582V12H2.46582V20H20.4658V12H22.4658V6H16.1225L17.0012 5.12132C18.1728 3.94975 18.1728 2.05025 17.0012 0.878677ZM14.1728 5.12132L15.587 3.70711C15.9775 3.31658 15.9775 2.68342 15.587 2.29289C15.1965 1.90237 14.5633 1.90237 14.1728 2.29289L12.7586 3.70711C12.3681 4.09763 12.3681 4.7308 12.7586 5.12132C13.1491 5.51184 13.7823 5.51184 14.1728 5.12132ZM9.58712 3.70714L8.17293 2.29293C7.7824 1.9024 7.14924 1.9024 6.75871 2.29293C6.36819 2.68345 6.36819 3.31662 6.75871 3.70714L8.17293 5.12136C8.56345 5.51188 9.19662 5.51188 9.58712 5.12136C9.97762 4.73083 9.97762 4.09767 9.58712 3.70714ZM20.4658 8V10H2.46582V8H20.4658ZM12.3825 12H18.4658V18H12.3825V12ZM10.5492 12V18H4.46582V12H10.5492Z"
      fill="white"
    />
  </svg>
);
const AddIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="25"
    height="24"
    className={className}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9141 5H2.91406V7H14.9141V5ZM14.9141 9H2.91406V11H14.9141V9ZM10.9141 13H2.91406V15H10.9141V13ZM18.9141 9H16.9141V13H12.9141V15H16.9141V19H18.9141V15H22.9141V13H18.9141V9Z"
      fill="#5243AA"
    />
  </svg>
);
const CheckIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41z"
    />
  </svg>
);
const QrCodeIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0H0V6H2V2H6V0ZM0 18V12H2V16H6V18H0ZM12 0V2H16V6H18V0H12ZM16 12H18V18H12V16H16V12ZM4 4H8V8H4V4ZM4 10H8V14H4V10ZM14 4H10V8H14V4ZM10 10H14V14H10V10Z"
      fill="#5243AA"
    />
  </svg>
);
const VerticalDropdownIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="5"
    height="16"
    className={className}
    viewBox="0 0 5 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.20075 4.62245C3.20424 4.62245 4.01784 3.80886 4.01784 2.80537C4.01784 1.80187 3.20424 0.988281 2.20075 0.988281C1.19726 0.988281 0.383667 1.80187 0.383667 2.80537C0.383667 3.80886 1.19726 4.62245 2.20075 4.62245ZM2.20075 1.89684C2.70271 1.89684 3.10931 2.30387 3.10931 2.8054C3.10931 3.30694 2.70274 3.71396 2.20075 3.71396C1.69876 3.71396 1.29219 3.30739 1.29219 2.8054C1.29219 2.30341 1.69876 1.89684 2.20075 1.89684Z"
      fill="#151411"
      fillOpacity="0.8"
    />
    <path
      d="M2.20075 11.8906C1.19726 11.8906 0.383667 12.7042 0.383667 13.7077C0.383667 14.7112 1.19726 15.5248 2.20075 15.5248C3.20424 15.5248 4.01784 14.7112 4.01784 13.7077C4.01784 12.7043 3.20424 11.8906 2.20075 11.8906ZM2.20075 14.6163C1.6988 14.6163 1.29219 14.2097 1.29219 13.7077C1.29219 13.2057 1.69876 12.7991 2.20075 12.7991C2.70274 12.7991 3.10931 13.2062 3.10931 13.7077C3.10931 14.2092 2.70271 14.6163 2.20075 14.6163Z"
      fill="#151411"
      fillOpacity="0.8"
    />
    <path
      d="M2.20075 6.43945C1.19726 6.43945 0.383667 7.25305 0.383667 8.25654C0.383667 9.26003 1.19726 10.0736 2.20075 10.0736C3.20424 10.0736 4.01784 9.26003 4.01784 8.25654C4.01784 7.25305 3.20424 6.43945 2.20075 6.43945ZM2.20075 9.16506C1.6988 9.16506 1.29219 8.75849 1.29219 8.2565C1.29219 7.75451 1.69876 7.34794 2.20075 7.34794C2.70274 7.34794 3.10931 7.75496 3.10931 8.2565C3.10928 8.75804 2.70271 9.16506 2.20075 9.16506Z"
      fill="#151411"
      fillOpacity="0.8"
    />
  </svg>
);
const AnalyticsGrowthIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="30"
    className={className}
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0365 0.62793H9.10586C3.92356 0.62793 0.834106 3.71738 0.834106 8.89968V20.8161C0.834106 26.0127 3.92356 29.1021 9.10586 29.1021H21.0223C26.2046 29.1021 29.2941 26.0127 29.2941 20.8304V8.89968C29.3083 3.71738 26.2188 0.62793 21.0365 0.62793ZM22.5599 11.9607L19.2711 16.2033C18.8583 16.7301 18.2745 17.0718 17.6054 17.143C16.9363 17.2284 16.2814 17.0433 15.7546 16.6304L13.1492 14.5803C13.1127 14.5483 13.0693 14.5252 13.0223 14.5128C12.9754 14.5005 12.9262 14.4992 12.8787 14.5091C12.8217 14.5091 12.7221 14.5376 12.6367 14.6515L9.24823 19.0507C9.03467 19.3212 8.72146 19.4636 8.40824 19.4636C8.18045 19.4636 7.95265 19.3924 7.75333 19.2358C7.64209 19.1507 7.54868 19.0446 7.47846 18.9234C7.40823 18.8023 7.36256 18.6685 7.34405 18.5296C7.32554 18.3908 7.33456 18.2497 7.37059 18.1144C7.40661 17.9791 7.46894 17.8522 7.55402 17.7409L10.9424 13.3417C11.3553 12.8149 11.939 12.4732 12.6082 12.3878C13.2631 12.3023 13.9322 12.4874 14.459 12.9003L17.0644 14.9504C17.1641 15.0359 17.2637 15.0359 17.3349 15.0216C17.3918 15.0216 17.4915 14.9932 17.5769 14.8793L20.8657 10.6366C20.9507 10.525 21.0572 10.4315 21.1789 10.3616C21.3006 10.2917 21.435 10.2469 21.5742 10.2296C21.7135 10.2124 21.8548 10.2231 21.9898 10.2612C22.1248 10.2993 22.2509 10.364 22.3606 10.4515C22.8304 10.8359 22.9158 11.5051 22.5599 11.9607Z"
      fill="#5243AA"
    />
  </svg>
);
const AnalyticsPeopleIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="34"
    height="25"
    viewBox="0 0 34 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.52892 13.3619C8.53071 13.5026 8.50431 13.6423 8.45129 13.7726C8.39826 13.903 8.31968 14.0214 8.22016 14.1209C8.12065 14.2204 8.00223 14.299 7.87187 14.3521C7.74151 14.4051 7.60185 14.4315 7.46113 14.4297H1.58833C1.38996 14.4281 1.19576 14.3726 1.02649 14.2691C0.857224 14.1657 0.719252 14.0182 0.627329 13.8424C0.541849 13.6634 0.506631 13.4645 0.525438 13.267C0.544246 13.0695 0.616373 12.8809 0.734107 12.7212C1.67908 11.4527 2.94003 10.4541 4.39126 9.82487C3.76767 9.25404 3.28855 8.54328 2.99333 7.75109C2.69812 6.9589 2.59525 6.10793 2.6932 5.26822C2.79114 4.4285 3.0871 3.62405 3.55672 2.92107C4.02633 2.21809 4.65617 1.63668 5.3944 1.2247C6.13263 0.812715 6.95815 0.581933 7.803 0.551347C8.64786 0.520761 9.4879 0.691247 10.254 1.04877C11.0201 1.40629 11.6903 1.94064 12.2095 2.60782C12.7287 3.275 13.0821 4.05594 13.2405 4.88638C13.28 5.10266 13.2526 5.32585 13.162 5.52617C13.0714 5.72648 12.9218 5.89441 12.7333 6.00755C11.007 7.03122 9.69407 8.62753 9.02276 10.5189C8.69184 11.4301 8.52465 12.3925 8.52892 13.3619ZM33.4082 12.7212C32.4633 11.4527 31.2023 10.4541 29.7511 9.82487C30.3747 9.25404 30.8538 8.54328 31.149 7.75109C31.4442 6.9589 31.5471 6.10793 31.4491 5.26822C31.3512 4.4285 31.0552 3.62405 30.5856 2.92107C30.116 2.21809 29.4862 1.63668 28.7479 1.2247C28.0097 0.812715 27.1842 0.581933 26.3393 0.551347C25.4945 0.520761 24.6544 0.691247 23.8884 1.04877C23.1223 1.40629 22.452 1.94064 21.9328 2.60782C21.4136 3.275 21.0602 4.05594 20.9018 4.88638C20.8624 5.10266 20.8897 5.32585 20.9804 5.52617C21.071 5.72648 21.2205 5.89441 21.409 6.00755C23.1376 7.0286 24.4513 8.62583 25.1196 10.5189C25.4505 11.4301 25.6177 12.3925 25.6134 13.3619C25.6116 13.5026 25.638 13.6423 25.6911 13.7726C25.7441 13.903 25.8227 14.0214 25.9222 14.1209C26.0217 14.2204 26.1401 14.299 26.2705 14.3521C26.4008 14.4051 26.5405 14.4315 26.6812 14.4297H32.554C32.7523 14.4297 32.9467 14.3745 33.1154 14.2702C33.2841 14.166 33.4204 14.0168 33.5091 13.8394C33.5977 13.6621 33.6353 13.4635 33.6175 13.266C33.5997 13.0685 33.5272 12.8799 33.4082 12.7212ZM20.9686 18.4472C22.0313 17.6327 22.8121 16.5057 23.2012 15.2246C23.5904 13.9435 23.5685 12.5726 23.1384 11.3046C22.7084 10.0366 21.8919 8.93522 20.8036 8.15518C19.7154 7.37514 18.4101 6.95564 17.0712 6.95564C15.7322 6.95564 14.427 7.37514 13.3387 8.15518C12.2505 8.93522 11.434 10.0366 11.0039 11.3046C10.5739 12.5726 10.5519 13.9435 10.9411 15.2246C11.3303 16.5057 12.1111 17.6327 13.1738 18.4472C11.0976 19.3689 9.41448 20.9954 8.42214 23.0387C8.34318 23.2011 8.30782 23.3812 8.31952 23.5614C8.33122 23.7416 8.38958 23.9156 8.48887 24.0664C8.58129 24.2211 8.71228 24.3492 8.86903 24.4381C9.02579 24.527 9.20293 24.5737 9.38314 24.5736H24.7592C24.9394 24.5737 25.1166 24.527 25.2733 24.4381C25.4301 24.3492 25.5611 24.2211 25.6535 24.0664C25.7528 23.9156 25.8111 23.7416 25.8228 23.5614C25.8345 23.3812 25.7992 23.2011 25.7202 23.0387C24.7279 20.9954 23.0447 19.3689 20.9686 18.4472Z"
      fill="#064E3B"
    />
  </svg>
);
const PhoneIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 4C5 2.34315 6.34315 1 8 1H16C17.6569 1 19 2.34315 19 4V20C19 21.6569 17.6569 23 16 23H8C6.34315 23 5 21.6569 5 20V4ZM8 3H16C16.5523 3 17 3.44772 17 4V20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20V4C7 3.44772 7.44771 3 8 3ZM10 5C10 5.55228 9.55228 6 9 6C8.44771 6 8 5.55228 8 5C8 4.44772 8.44771 4 9 4C9.55228 4 10 4.44772 10 5ZM9 9C9.55228 9 10 8.55228 10 8C10 7.44772 9.55228 7 9 7C8.44771 7 8 7.44772 8 8C8 8.55228 8.44771 9 9 9ZM9 20C9.55228 20 10 19.5523 10 19C10 18.4477 9.55228 18 9 18C8.44771 18 8 18.4477 8 19C8 19.5523 8.44771 20 9 20ZM9 12C9.55228 12 10 11.5523 10 11C10 10.4477 9.55228 10 9 10C8.44771 10 8 10.4477 8 11C8 11.5523 8.44771 12 9 12ZM12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6ZM12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9ZM12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20ZM15 6C15.5523 6 16 5.55228 16 5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6ZM15 9C15.5523 9 16 8.55228 16 8C16 7.44772 15.5523 7 15 7C14.4477 7 14 7.44772 14 8C14 8.55228 14.4477 9 15 9ZM15 20C15.5523 20 16 19.5523 16 19C16 18.4477 15.5523 18 15 18C14.4477 18 14 18.4477 14 19C14 19.5523 14.4477 20 15 20Z"
      fill="#151411"
      fillOpacity="0.6"
    />
  </svg>
);
const BankIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M11.5 1L2 6v2h19V6m-5 4v7h3v-7M2 22h19v-3H2m8-9v7h3v-7m-9 0v7h3v-7H4Z"
    />
  </svg>
);
const CodeIcon = ({
  color = '#8F92A1',
  width = '29',
  height = '21',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 1024 1024"
  >
    <path
      fill="currentColor"
      d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z"
    />
  </svg>
);
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="32"
  height="32"
  viewBox="0 0 32 32"
>
  <path
    fill="currentColor"
    d="M24 21h2v5h-2zm-4-5h2v10h-2zm-9 10a5.006 5.006 0 0 1-5-5h2a3 3 0 1 0 3-3v-2a5 5 0 0 1 0 10z"
  />
  <path
    fill="currentColor"
    d="M28 2H4a2.002 2.002 0 0 0-2 2v24a2.002 2.002 0 0 0 2 2h24a2.003 2.003 0 0 0 2-2V4a2.002 2.002 0 0 0-2-2Zm0 9H14V4h14ZM12 4v7H4V4ZM4 28V13h24l.002 15Z"
  />
</svg>;

export {
  CodeIcon,
  BankIcon,
  PhoneIcon,
  AnalyticsGrowthIcon,
  AnalyticsPeopleIcon,
  VerticalDropdownIcon,
  QrCodeIcon,
  CheckIcon,
  AddIcon,
  GiftIcon,
  MarketingIcon,
  ShortArrowRightIcon,
  ShortArrowLeftIcon,
  PaginationLeftIcon,
  PaginationRightIcon,
  MenuIcon,
  EmptyStateIcon,
  ThickDownArrow,
  ShareIcon,
  ChevronRight,
  SettingsIcon,
  PushNotificationsIcon,
  XMarkIcon,
  FileUploadIcon,
  LongArrowLeftIcon,
  ThreeDotsIcon,
  PlusIcon,
  LogoutIcon,
  InfoIcon,
  ChevronFillDownIcon,
  ProfileIcon,
  StoreIcon,
  FileIcon,
  ChevronUpIcon,
  CustomerIcon,
  AnalyticsIcon,
  DashboardIcon,
  EyeIcon,
  EyeClosedIcon,
  SearchIcon,
  BellIcon,
  StaffIcon,
  ChevronDownIcon,
  ListIcon,
};
